import { DownloadButton, ColumnTogglerButton } from "_components/buttons";
import SearchInput from "_components/SearchInput";
import { CustomTable } from "_components/table/CustomTable";
import { eventsActions, vehicleActions } from "_store";
//import { selectEventsTotalCount } from "_store/selectors/alerts.selector";
import { sidePanelActions } from "_store/sidePanel.slice";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

export { AlertsTableReport }

function AlertsTableReport ({limit = false, maxHeight = '440px'}) {
    
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);

    //const eventsCount = useSelector(selectEventsTotalCount);

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const events = useSelector(state => state.events);
    const filter = useSelector(state => state.filters?.item);
    const [filterSelected, setFilterSelected] = useState(null);

    const handleShowSidePanel = (alert) => {
        dispatch(sidePanelActions.openPanel({ type: 'alert', data: alert }));        
    }

    const handleViewBus = (item) => {
        dispatch(vehicleActions.setVehicle(item));
        navigate(`bus/${item.HEADER_VIN}`)
    }

    const handleViewDiagLog = (item) => {
        //ispatch(vehicleActions.setVehicle(item));
        navigate(`/diagnostic/${item.HEADER_VIN}`)
    }

    /** Différenciation des données à récupérer en fonction de la page actuelle
     *      - Le paramètre 'limit' indique que le composant est utilisé sur la page contenant la carte, 
     *        Il ne faut afficher que les 100 dernières événements 
     *      - L'absence de paramètre indique que le composant est appelé sur la page Alertes (RAPPORT)
     *        Il ne faut afficher que les alertes et préalertes sur la journée actuelle */  
    useEffect(() => {
        if(limit)
            dispatch(eventsActions.getLastEvents());            
        else
            dispatch(eventsActions.getAlertsAndPreAlerts());

        return () => {
            dispatch(eventsActions.clearData());
        };
    }, [])

    useEffect(() => {
           setFilterSelected(filter)         
    }, [filter])

    useEffect(() => {
        if (events?.data?.events && !limit) {
            //les alertes remontées suite à une pré alerte on le niveau à 0
            //la valeur est modifiée pour ne rien afficher dans le tableau
            const updatedData = events.data.events.map(item => {
                return {
                    ...item,
                    URGENCY_LEVEL: item.URGENCY_LEVEL === "0" ? "" : item.URGENCY_LEVEL
                };
            });
            setData(updatedData);
            setFilteredData(updatedData);
        } else if(events?.data?.events) {
            setData(events.data.events);
            setFilteredData(events.data.events);
        }
    }, [events]);


    const headers = [
        { label: 'Flotte', key: 'METROPOLIS', type: 'string', canToggle: false, visible: true },
        { label: 'Parc', key: 'PARK_NUMBER', type: 'string', canToggle: false, visible: true },
        { label: 'VIN', key: 'HEADER_VIN', type: 'string', canToggle: false, visible: true },
        { label: "Code", key: '', type: 'string', icon: 'HEADER_CODE', canToggle: false, visible: true },
        { label: "Description", key: 'EVENT_DESC_FR', type: 'string', canToggle: false, visible: true },
        { label: 'Niveau', key: 'URGENCY_LEVEL', type: 'string', canToggle: false, visible: true },
        { label: 'Date et Heure', key: 'HEADER_EVTDATE', type: 'string', canToggle: false, visible: true },
        { label: 'SOC', key: 'CONTEXT.SOC', type: 'string', canToggle: true, visible: true },
        { label: 'Odomètre', key: 'HEADER_DST', type: 'string', canToggle: true, visible: true },
        { label: 'Autonomie', key: 'CONTEXT.RANGE', type: 'string', canToggle: true, visible: false },        
        { label: 'Statut', key: 'CONTEXT.VHM', type: 'string', canToggle: true, visible: false },   
        { label: 'Pays', key: 'COUNTRY', type: 'string', canToggle: true, visible: false },    
    ]

    if (limit){
        headers.push(
            { label: '', key: 'bus_info', type: 'action', action: handleViewBus, icon: 'viewBus', canToggle: false, visible: true, title: 'Voir le détail du bus'},
            { label: '', key: 'alert_info', type: 'action', action: handleShowSidePanel, icon: 'loupeOutlined', canToggle: false, visible: true, title: 'Voir le détail de l\'alerte'}
        )
    } else {
         headers.push(
            { label: '', key: 'diag_log_info', type: 'action', action: handleViewDiagLog, icon: 'infoOutlined', canToggle: false, visible: true, title: 'Voir les données diagnostic logger du bus'},
            { label: '', key: 'alert_info', type: 'action', action: handleShowSidePanel, icon: 'loupeOutlined', canToggle: false, visible: true, title: 'Voir le détail de l\'alerte'}
        )
    }

    /**Gestion de l'état d'affichage de la div de sélection de colonnes */
    const [visibleColumns, setVisibleColumns] = useState(
        headers.map(header => ({ ...header, visible: header.visible }))
    );    

    const toggleColumnVisibility = (index) => {
        const newColumns = [...visibleColumns];
        newColumns[index].visible = !newColumns[index].visible;
        setVisibleColumns(newColumns);
    };       

    // Fonction pour mettre à jour les données filtrées
    const handleFilteredData = (newFilteredData) => {
        if (JSON.stringify(newFilteredData) !== JSON.stringify(filteredData)) {
            setFilteredData(newFilteredData);
        }
    };
    
    return (
        <>
            {data && (
                <div className='custom-table-container'>
                    <div className={'flex justify-between items-end'}>
                        {limit ? 
                            (<div className="flex flex-col">
                                <div className="flex items-center">
                                    <span className={'title-customtable'}>{filteredData?.length}</span>
                                    <span className={'small-title-customtable'}>{` Derniers Evènements`}</span>
                                </div>
                            </div>
                            ) : (
                            <div className="flex flex-col">
                                <div className="flex items-center mb-4">
                                    <span className={'title-customtable'}>RAPPORT</span>                                                           
                                </div>                            
                                <div className="flex items-end">
                                    <span className={'small-title-customtable mr-2 '}>
                                        {filteredData?.length}                                
                                    </span>
                                    <i className="pb-0.5"> événements survenus depuis le début de la journée</i>
                                </div>
                                {filterSelected && 
                                    <div className="mt-2">
                                        Filtre appliqué : <strong>{filterSelected.name}</strong> 
                                    </div>}
                            </div>)
                        }                                       
                        <div className='flex gap-6'>
                            <SearchInput data={data} onFilteredData={handleFilteredData} />
                            <DownloadButton title={'Rapport des alertes'} headers={headers} data={filteredData} />
                            <ColumnTogglerButton
                                visibleColumns={visibleColumns}
                                toggleColumnVisibility={toggleColumnVisibility}
                            />
                        </div>
                    </div>
                    <div className={"my-4 "}>
                        <CustomTable data={filteredData} headers={visibleColumns} maxHeight={maxHeight} paginate={true} limit={limit}/>
                    </div>
                </div>
            )}
        </>
    )    
}